import { ReactComponent as LogoSVG } from '../assets/logo.svg';

export default function Logo({ color = '#1A2340', height = 28, className = '' }) {
  return (
    <LogoSVG
      className={className}
      style={{ color, height, width: 'auto', display: 'block' }}
    />
  );
}
